//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: () => ({
        mobile:'400-901-6886'
    }),
    methods: {
        // 拨打电话
      callTel(mobile){
        const a = document.createElement("a");
        a.href = "tel:"+mobile+""
        a.click();
      }, 
        
    },
    mounted() {
       
    }
}
